<template>
    <div>
        <div class="common-header">
            <div>
                <el-button type="primary" @click="detailFunc(selection)">一键回复</el-button>
            </div>
            <div class="common-header-right">
                <div class="common-header-block">
                    处理状态：
                    <el-select v-model="status">
                        <el-option
                                v-for="item of statusOptions"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value"/>
                    </el-select>
                </div>
                <div class="common-header-block">
                    反馈类型：
                    <el-select v-model="type">
                        <el-option
                                v-for="item of typeOptions"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value"/>
                    </el-select>
                </div>
                <div class="common-header-block">
                    <el-date-picker
                            v-model="date"
                            format="yyyy-MM-dd HH:mm"
                            type="datetimerange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"/>
                </div>
                <div class="common-header-block">
                    <el-button type="primary" @click="getList()">搜索</el-button>
                </div>
            </div>

        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    height="100%"
                    row-key="id"
                    @selection-change="selection = $event"
                    :data="userFeedbackList.beanList">
                <el-table-column type="selection" align="center"/>
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="反馈玩家ID" min-width="120" align="center" prop="userId"/>
                <el-table-column label="反馈玩家昵称" min-width="150" align="center" prop="nickname"/>
				<el-table-column label="反馈信息" min-width="200" align="center" prop="message"/>
                <el-table-column label="反馈时间" min-width="150" align="center" prop="createTime"/>
                <el-table-column label="状态" align="center">
                    <template slot-scope="scope">{{scope.row.status?'已回复':'未处理'}}</template>
                </el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="detailFunc([scope.row])">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                background
                layout="prev,pager,next,jumper"
                :page-size="20"
                :pager-count="5"
                :total="userFeedbackList.total"
                @current-change="getList($event)"
                :current-page="currentPage"/>

        <div v-show="show" class="common-popup-bg">
            <div style="width: 500px" class="common-popup">
                <h3>意见反馈</h3>
                <i class="common-popup-close el-icon-close" @click="show = false"></i>
                <div class="common-popup-table">
                    <template v-if="complaintContent">
                        <h4>投诉内容：</h4>
                        <p style="padding: 10px 0;" v-text="complaintContent"></p>
                    </template>
                    <h4>处理反馈：{{recive}}</h4>
                    <el-input
                            v-model="content"
                            style="padding: 10px 0 20px;"
                            type="textarea"
                            resize="none"
                            rows="3"
                            placeholder="您好，您的反馈内容我们已处理，感谢您一路以来的支持和信任"/>
                </div>
                <footer>
                    <el-button type="primary" size="small" @click="submitFunc">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                date: null,
                type: '',
                typeOptions: [
                    {label: '全部', value: ''},
                    {label: '伙牌', value: 1},
                    // {label: '外挂', value: 2},
                    {label: '其他', value: 3},
                ],
                status: -1,
                statusOptions: [
                    {label: '全部', value: -1},
                    {label: '未处理', value: 0},
                    {label: '已处理', value: 1},
                ],
                currentPage: 1,
                show: false,
                selection: [],
                complaintContent: '',//投诉内容
                content: '',// 回复内容
				recive: '',// 已回复内容
                idList: [],
				msgId:"",
            }
        },
        computed: {
            ...mapState('complaint', ['userFeedbackList']),
        },
        created() {
            this.getList()
        },
        filters: {
            typeName(type) {
                let arr = ['伙牌', '外挂', '其他'];
                return arr[type - 1];
            }
        },
        methods: {
            ...mapActions('complaint', ['getUserFeedbackList', 'updateUserFeedback']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getUserFeedbackList({
                    type: this.type,
                    status: this.status,
                    startTime: this.date && this.date[0],
                    endTime: this.date && this.date[1],
                    page
                }).then(() => {
                    this.loading = false;
                })
            },

            detailFunc(rows) {
				
				console.log(rows);
                if (!rows.length) {
                    this.$message.error('请先选择您要回复的玩家');
                    return
                }
                if (rows.length === 1) {
                    this.complaintContent = rows[0].message;
					this.msgId=rows[0].msgId;
					this.recive=rows[0].recive;
                } else {
                    this.complaintContent = '';
					this.msgId='';
					this.recive='';
                }
				
                this.idList = rows.map(item => item.userId);
                this.show = true;
            },
            submitFunc() {
				
				let params ={
						sendToRandomIds:this.idList,
						sendType:2,
						pushSwitch:0,
						zhContent: this.content,// 简体
						hkContent: this.content,// 繁体
						usContent: this.content,// 英文
						sendTimeType:1,
						sentTime: '',
						msgId: this.msgId
					};
                this.updateUserFeedback(params).then(() => {
                    this.show = false;
                    this.$message.success('请求成功');
                    this.getList(this.currentPage);
                })
            }
        }
    }
</script>